export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTHS_BN = [
  'জানুয়ারি',
  'ফেব্রুয়ারি',
  'মার্চ',
  'এপ্রিল',
  'মে',
  'জুন',
  'জুলাই',
  'আগস্ট',
  'সেপ্টেম্বর',
  'অক্টোবর',
  'নভেম্বর',
  'ডিসেম্বর',
];

export const DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const DAYS_BN = [
  'সোমবার',
  'মঙ্গলবার',
  'বুধবার',
  'বৃহস্পতিবার',
  'শুক্রবার',
  'শনিবার',
  'রবিবার',
];

export const ALL_DESCRIPTIONS = [
  { icon: 'clearsky_day.svg', description: 'clearsky_day' },
  { icon: 'clearsky_night.svg', description: 'clearsky_night' },
  { icon: 'cloudy.svg', description: 'cloudy' },
  { icon: 'fair_day.svg', description: 'fair_day' },
  { icon: 'fair_night.svg', description: 'fair_night' },
  { icon: 'fog.svg', description: 'fog' },
  { icon: 'heavyrain.svg', description: 'heavyrain' },
  { icon: 'heavyrainandthunder.svg', description: 'heavyrainandthunder' },
  { icon: 'heavyrainshowers_day.svg', description: 'heavyrainshowers_day' },
  { icon: 'heavyrainshowers_night.svg', description: 'heavyrainshowers_night' },
  { icon: 'heavyrainshowersandthunder_day.svg', description: 'heavyrainshowersandthunder_day' },
  { icon: 'heavyrainshowersandthunder_night.svg', description: 'heavyrainshowersandthunder_night' },
  { icon: 'heavysleet.svg', description: 'heavysleet' },
  { icon: 'heavysleetandthunder.svg', description: 'heavysleetandthunder' },
  { icon: 'heavysleetshowers_day.svg', description: 'heavysleetshowers_day' },
  { icon: 'heavysleetshowers_night.svg', description: 'heavysleetshowers_night' },
  { icon: 'heavysleetshowersandthunder_day.svg', description: 'heavysleetshowersandthunder_day' },
  { icon: 'heavysleetshowersandthunder_night.svg', description: 'heavysleetshowersandthunder_night' },
  { icon: 'heavysnow.svg', description: 'heavysnow' },
  { icon: 'heavysnowandthunder.svg', description: 'heavysnowandthunder' },
  { icon: 'heavysnowshowers_day.svg', description: 'heavysnowshowers_day' },
  { icon: 'heavysnowshowers_night.svg', description: 'heavysnowshowers_night' },
  { icon: 'heavysnowshowersandthunder_day.svg', description: 'heavysnowshowersandthunder_day' },
  { icon: 'heavysnowshowersandthunder_night.svg', description: 'heavysnowshowersandthunder_night' },
  { icon: 'lightrain.svg', description: 'lightrain' },
  { icon: 'lightrainandthunder.svg', description: 'lightrainandthunder' },
  { icon: 'lightrainshowers_day.svg', description: 'lightrainshowers_day' },
  { icon: 'lightrainshowers_night.svg', description: 'lightrainshowers_night' },
  { icon: 'lightrainshowersandthunder_day.svg', description: 'lightrainshowersandthunder_day' },
  { icon: 'lightrainshowersandthunder_night.svg', description: 'lightrainshowersandthunder_night' },
  { icon: 'lightsleet.svg', description: 'lightsleet' },
  { icon: 'lightsleetandthunder.svg', description: 'lightsleetandthunder' },
  { icon: 'lightsleetshowers_day.svg', description: 'lightsleetshowers_day' },
  { icon: 'lightsleetshowers_night.svg', description: 'lightsleetshowers_night' },
  { icon: 'lightsleetshowersandthunder_day.svg', description: 'lightsleetshowersandthunder_day' },
  { icon: 'lightsleetshowersandthunder_night.svg', description: 'lightsleetshowersandthunder_night' },
  { icon: 'lightsnow.svg', description: 'lightsnow' },
  { icon: 'lightsnowandthunder.svg', description: 'lightsnowandthunder' },
  { icon: 'lightsnowshowers_day.svg', description: 'lightsnowshowers_day' },
  { icon: 'lightsnowshowers_night.svg', description: 'lightsnowshowers_night' },
  { icon: 'lightsnowshowersandthunder_day.svg', description: 'lightsnowshowersandthunder_day' },
  { icon: 'lightsnowshowersandthunder_night.svg', description: 'lightsnowshowersandthunder_night' },
  { icon: 'partlycloudy_day.svg', description: 'partlycloudy_day' },
  { icon: 'partlycloudy_night.svg', description: 'partlycloudy_night' },
  { icon: 'rain.svg', description: 'rain' },
  { icon: 'rainandthunder.svg', description: 'rainandthunder' },
  { icon: 'rainshowers_day.svg', description: 'rainshowers_day' },
  { icon: 'rainshowers_night.svg', description: 'rainshowers_night' },
  { icon: 'rainshowersandthunder_day.svg', description: 'rainshowersandthunder_day' },
  { icon: 'rainshowersandthunder_night.svg', description: 'rainshowersandthunder_night' },
  { icon: 'sleet.svg', description: 'sleet' },
  { icon: 'sleetandthunder.svg', description: 'sleetandthunder' },
  { icon: 'sleetshowers_day.svg', description: 'sleetshowers_day' },
  { icon: 'sleetshowers_night.svg', description: 'sleetshowers_night' },
  { icon: 'sleetshowersandthunder_day.svg', description: 'sleetshowersandthunder_day' },
  { icon: 'sleetshowersandthunder_night.svg', description: 'sleetshowersandthunder_night' },
  { icon: 'snow.svg', description: 'snow' },
  { icon: 'snowandthunder.svg', description: 'snowandthunder' },
  { icon: 'snowshowers_day.svg', description: 'snowshowers_day' },
  { icon: 'snowshowers_night.svg', description: 'snowshowers_night' },
  { icon: 'snowshowersandthunder_day.svg', description: 'snowshowersandthunder_day' },
  { icon: 'snowshowersandthunder_night.svg', description: 'snowshowersandthunder_night' },
  { icon: 'fog.svg', description: 'fog' },
  { icon: 'heavyrainshowers_day.svg', description: 'heavyrainshowers_day' },
  { icon: 'heavyrainshowers_night.svg', description: 'heavyrainshowers_night' }
];

export const ALL_DESCRIPTIONS_BN = {
  clearsky_day: 'পরিষ্কার আকাশ (দিন)',
  clearsky_night: 'পরিষ্কার আকাশ (রাত)',
  cloudy: 'মেঘলা',
  fair_day: 'পরিষ্কার (দিন)',
  fair_night: 'পরিষ্কার (রাত)',
  fog: 'কুয়াশা',
  heavyrain: 'ভারী বৃষ্টি',
  heavyrainandthunder: 'ভারী বৃষ্টি ও বজ্রপাত',
  heavyrainshowers_day: 'ভারী বৃষ্টির ঝড় (দিন)',
  heavyrainshowers_night: 'ভারী বৃষ্টির ঝড় (রাত)',
  heavyrainshowersandthunder_day: 'ভারী বজ্রসহ বৃষ্টির ঝড় (দিন)',
  heavyrainshowersandthunder_night: 'ভারী বজ্রসহ বৃষ্টির ঝড় (রাত)',
  heavysleet: 'ভারী শিলাবৃষ্টি',
  heavysleetandthunder: 'ভারী শিলাবৃষ্টি ও বজ্রপাত',
  heavysleetshowers_day: 'ভারী শিলাবৃষ্টির ঝড় (দিন)',
  heavysleetshowers_night: 'ভারী শিলাবৃষ্টির ঝড় (রাত)',
  heavysleetshowersandthunder_day: 'ভারী বজ্রসহ শিলাবৃষ্টির ঝড় (দিন)',
  heavysleetshowersandthunder_night: 'ভারী বজ্রসহ শিলাবৃষ্টির ঝড় (রাত)',
  heavysnow: 'ভারী তুষারপাত',
  heavysnowandthunder: 'ভারী তুষারপাত ও বজ্রপাত',
  heavysnowshowers_day: 'ভারী তুষারপাতের ঝড় (দিন)',
  heavysnowshowers_night: 'ভারী তুষারপাতের ঝড় (রাত)',
  heavysnowshowersandthunder_day: 'ভারী বজ্রসহ তুষারপাতের ঝড় (দিন)',
  heavysnowshowersandthunder_night: 'ভারী বজ্রসহ তুষারপাতের ঝড় (রাত)',
  lightrain: 'হালকা বৃষ্টি',
  lightrainandthunder: 'হালকা বৃষ্টি ও বজ্রপাত',
  lightrainshowers_day: 'হালকা বৃষ্টির ঝড় (দিন)',
  lightrainshowers_night: 'হালকা বৃষ্টির ঝড় (রাত)',
  lightrainshowersandthunder_day: 'হালকা বজ্রসহ বৃষ্টির ঝড় (দিন)',
  lightrainshowersandthunder_night: 'হালকা বজ্রসহ বৃষ্টির ঝড় (রাত)',
  lightsleet: 'হালকা শিলাবৃষ্টি',
  lightsleetandthunder: 'হালকা শিলাবৃষ্টি ও বজ্রপাত',
  lightsleetshowers_day: 'হালকা শিলাবৃষ্টির ঝড় (দিন)',
  lightsleetshowers_night: 'হালকা শিলাবৃষ্টির ঝড় (রাত)',
  lightsleetshowersandthunder_day: 'হালকা বজ্রসহ শিলাবৃষ্টির ঝড় (দিন)',
  lightsleetshowersandthunder_night: 'হালকা বজ্রসহ শিলাবৃষ্টির ঝড় (রাত)',
  lightsnow: 'হালকা তুষারপাত',
  lightsnowandthunder: 'হালকা তুষারপাত ও বজ্রপাত',
  lightsnowshowers_day: 'হালকা তুষারপাতের ঝড় (দিন)',
  lightsnowshowers_night: 'হালকা তুষারপাতের ঝড় (রাত)',
  lightsnowshowersandthunder_day: 'হালকা বজ্রসহ তুষারপাতের ঝড় (দিন)',
  lightsnowshowersandthunder_night: 'হালকা বজ্রসহ তুষারপাতের ঝড় (রাত)',
  partlycloudy_day: 'আংশিক মেঘলা (দিন)',
  partlycloudy_night: 'আংশিক মেঘলা (রাত)',
  rain: 'বৃষ্টি',
  rainandthunder: 'বৃষ্টি ও বজ্রপাত',
  rainshowers_day: 'বৃষ্টির ঝড় (দিন)',
  rainshowers_night: 'বৃষ্টির ঝড় (রাত)',
  rainshowersandthunder_day: 'বজ্রসহ বৃষ্টির ঝড় (দিন)',
  rainshowersandthunder_night: 'বজ্রসহ বৃষ্টির ঝড় (রাত)',
  sleet: 'শিলাবৃষ্টি',
  sleetandthunder: 'শিলাবৃষ্টি ও বজ্রপাত',
  sleetshowers_day: 'শিলাবৃষ্টির ঝড় (দিন)',
  sleetshowers_night: 'শিলাবৃষ্টির ঝড় (রাত)',
  sleetshowersandthunder_day: 'বজ্রসহ শিলাবৃষ্টির ঝড় (দিন)',
  sleetshowersandthunder_night: 'বজ্রসহ শিলাবৃষ্টির ঝড় (রাত)',
  snow: 'তুষারপাত',
  snowandthunder: 'তুষারপাত ও বজ্রপাত',
  snowshowers_day: 'তুষারপাতের ঝড় (দিন)',
  snowshowers_night: 'তুষারপাতের ঝড় (রাত)',
  snowshowersandthunder_day: 'বজ্রসহ তুষারপাতের ঝড় (দিন)',
  snowshowersandthunder_night: 'বজ্রসহ তুষারপাতের ঝড় (রাত)',

};